// Material UI
import { makeStyles } from '@material-ui/core';
// Consts
import Colors from '../../../constants/Colors';

export default makeStyles(theme => {
  return {
    badge: {
      backgroundColor: Colors.SECONDARY_FONT_COLOR,
      borderRadius: '50%',
      color: Colors.WHITE,
      fontSize: 13,
      height: 24,
      lineHeight: '1.85',
      textAlign: 'center',
      width: 24,
    },
    body: {
      height: '100%',
      overflow: 'auto',
      padding: '0px 20px 20px 20px',
      position: 'relative',
    },
    chipContainer: {
      left: '50%',
      marginTop: 24,
      position: 'absolute',
      transform: 'translateX(-50%)',
      '-webkit-transform': 'translateX(-50%)',
      width: '100%',
      zIndex: 10,
    },
    column: {
      backgroundColor: Colors.WHITE,
      flexDirection: 'column',
      display: 'flex',
      height: '100%',
    },
    header: {
      alignItems: 'center',
      borderBottom: `solid 1px ${Colors.DISABLED_COLOR}`,
      color: Colors.PRIMARY_FONT_COLOR,
      display: 'flex',
      fontFamily: 'Poppins',
      fontSize: 24,
      fontStretch: 'normal',
      fontStyle: 'normal',
      fontWeight: 'bold',
      justifyContent: 'space-between',
      letterSpacing: 'normal',
      lineHeight: 'normal',
      padding: '18px 20px 17px 20px',
    },
    root: {
      height: '100%',
      padding: '8px 16px',
      width: '100%',
      [theme.breakpoints.up('md')]: {
        padding: '0px 5px',
      },
      [theme.breakpoints.up('lg')]: {
        padding: '0px 8px',
      },
    },
    title: {},
    childrenContainer: {
      marginTop: '1.5rem',
      display: 'flex',
      flexDirection: 'column',
      gap: '0.5rem',
    },
  };
});
